import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
// import { requestPassword } from "../_redux/authCrud";
import {Form} from "react-bootstrap";
import { makeStyles } from '@material-ui/core';   
import { Link } from "react-router-dom";
import { useOktaAuth } from '@okta/okta-react';


const useStyles = makeStyles(theme => ({
  alertMsg: {
    color: 'red'
  },
  successMsg: {
    color: 'green'
  }
}));
const initialValues = {
  email: ""
};

export function ForgotPassword(props) {
  const { oktaAuth } = useOktaAuth();
  const { intl } = props;
  // const [isRequested, setIsRequested] = useState(false);
  const [loading, setLoading] = useState(false);
  const [responseStatus, setResponse] = useState(false);
  const [errorMsg, setMessage] = useState("");
  const [mailCheck, setMailCheck] = useState(false);
  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email("Wrong email format")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        })
      )
  });

  const classes = useStyles();

  const enableLoading = () => {
    setLoading(true);
  };
  const disableLoading = () => {
    setLoading(false);
  };
  const disableMessage = () => {
    setResponse(false);
  }
  const enableMessage = () => {
    setResponse(true);
  }

  // const getInputClasses = (fieldname) => {
  //   if (formik.touched[fieldname] && formik.errors[fieldname]) {
  //     return "is-invalid";
  //   }

  //   if (formik.touched[fieldname] && !formik.errors[fieldname]) {
  //     return "is-valid";
  //   }

  //   return "";
  // };

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();
      disableMessage();
      oktaAuth.forgotPassword({factorType:'EMAIL',relayState:"",username:values.email})
        .then((res) => {
        // setIsRequested(true);
        if (res.data.status) {
          setSubmitting(false);
          disableLoading();
          enableMessage();
          setMessage(res.data.message);
          setMailCheck(true);
          // props.history.push('/auth/login',{isMessage:true,message:res.data.message});
        }else{
          setSubmitting(false);
          disableLoading();
          enableMessage();
          setMessage(res.data.message);
        }
      })
        .catch((error) => {
          // setIsRequested(false);
          setSubmitting(false);
          disableLoading();
          enableMessage();
          // setMessage(error.response.data.message);
          // setStatus(
          //   intl.formatMessage(
          //     { id: "AUTH.VALIDATION.NOT_FOUND" },
          //     { name: values.email }
          //   )
          // );
        });
    }
  });

  return (
    // <>
    //   {isRequested && <Redirect to="/auth" />}
    //   {!isRequested && (
    //     <div className="login-form login-forgot" style={{ display: "block" }}>
    //       <div className="text-center mb-10 mb-lg-20">
    //         <h3 className="font-size-h1">Forgotten Password ?</h3>
    //         <div className="text-muted font-weight-bold">
    //           Enter your email to reset your password
    //         </div>
    //       </div>
    //       <form
    //         onSubmit={formik.handleSubmit}
    //         className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
    //       >
    //         {formik.status && (
    //           <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
    //             <div className="alert-text font-weight-bold">
    //               {formik.status}
    //             </div>
    //           </div>
    //         )}
    //         <div className="form-group fv-plugins-icon-container">
    //           <input
    //             type="email"
    //             className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
    //               "email"
    //             )}`}
    //             name="email"
    //             {...formik.getFieldProps("email")}
    //           />
    //           {formik.touched.email && formik.errors.email ? (
    //             <div className="fv-plugins-message-container">
    //               <div className="fv-help-block">{formik.errors.email}</div>
    //             </div>
    //           ) : null}
    //         </div>
    //         <div className="form-group d-flex flex-wrap flex-center">
    //           <button
    //             id="kt_login_forgot_submit"
    //             type="submit"
    //             className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
    //             disabled={formik.isSubmitting}
    //           >
    //             Submit
    //           </button>
    //           <Link to="/auth">
    //             <button
    //               type="button"
    //               id="kt_login_forgot_cancel"
    //               className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
    //             >
    //               Cancel
    //             </button>
    //           </Link>
    //         </div>
    //       </form>
    //     </div>
    //   )}
    // </>


    <div>
      <div className="vertical-center outer">
        <div className="shadow-lg box" style={{minWidth: '35%'}}>
          <div align="center">
            <h3 style={{width:"100%"}}><b>Forgot Passsword ?</b></h3>
          </div>
          <div align="center" >
            <Form style={{marginTop:"10%"}} onSubmit={formik.handleSubmit}>
              <Form.Group controlId="formGroupEmail">
                <div align="left"><Form.Label>Email</Form.Label></div>
                <Form.Control className="form-control" type="email" style={{border:"1px solid black"}} name="email"
                    {...formik.getFieldProps("email")}
                    required/>
                    {formik.touched.email && formik.errors.email ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block d-flex p-2">{formik.errors.email}</div>
                    </div>
                  ) : null}
              </Form.Group>
            <div align="center" style={{marginTop:"15%"}}>
              <button className="btn btn-lg btn-block vertical-center" style={{cursor: "pointer",border:"1px solid black"}} type="submit"><span><b>Submit</b></span>{loading && <span className="ml-3 spinner spinner-dark"></span>}</button>
              {responseStatus ? (<div className={`d-flex p-2 ${classes.alertMsg}`}>{errorMsg}</div>) : ''}
              {mailCheck ? (<div className={`d-flex p-2 ${classes.successMsg}`}>recovery password link has been send to your mail</div>) : ''}
            </div>
            </Form>
            <div style={{marginTop:"1%",cursor:"pointer"}}>
              <Link to="/auth/login" style={{color:"black"}}><p>Back to Login</p></Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(ForgotPassword));
